import { render, staticRenderFns } from "./receiptpayment.vue?vue&type=template&id=d785664a&"
import script from "./receiptpayment.vue?vue&type=script&lang=js&"
export * from "./receiptpayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports